import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sage = defineConnector({
  identifier: "sage",
  name: "Sage",
  tagLine: "Accounting and business management software",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.sage\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Sage app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Sage Developer Portal](https://developer.sage.com/) and create a new app. Select the Sage product you want to connect to (e.g., Sage Business Cloud Accounting).",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app's settings, add the following callback URL:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/sage/callback",
        },
      ],
    },
    {
      title: "Copy your app credentials",
      items: [
        {
          kind: "markdown",
          content:
            "From your app's configuration page, copy the **Client ID** and **Client secret**.",
        },
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Sage account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Sage account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://www.sageone.com/oauth2/auth/central?filter=apiv3.1",
    tokenEndpoint: () => "https://oauth.accounting.sage.com/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => ["full_access"],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.sage.com/accounting/v3.1/me",
  },
});
